import { cloneDeep } from 'lodash';
import request from '@/utils/request';
import { hasMinimumLength } from '@/utils/resultsHelper';
import { endpoints, datasetEndpoint } from '@/constants/urls';
import { isCommonsModeEnabled } from '@/auth/featureToggles';
import { transformForm } from '@/forms/state/state';
import { sanitizedDataset } from './helper';
import { transformDictionaries } from './dictionaries/state/state';

const datasets = (
  filter,
  privateFlag,
  internalFlag,
  publicFlag,
  dataModelCode,
  page,
  pageSize,
  requestable,
  queryable,
  orderBy,
) => {
  const params = { filter, page, pageSize };

  if (requestable) {
    params.requestable = true;
  }

  if (queryable) {
    params.queryable = true;
  }

  if (isCommonsModeEnabled()) {
    const visibilityFlags = [privateFlag, internalFlag, publicFlag];
    const allSet = visibilityFlags.every((v) => v === visibilityFlags[0]);

    if (!allSet) {
      if (privateFlag) {
        params.private = true;
      }
      if (internalFlag) {
        params.internal = true;
      }
      if (publicFlag) {
        params.public = true;
      }
    }
  } else if (privateFlag !== internalFlag) {
    if (privateFlag) {
      params.private = true;
    }
    if (internalFlag) {
      params.internal = true;
    }
  }

  if (dataModelCode) {
    params.dataModelCode = dataModelCode;
  }

  if (orderBy) {
    params.orderBy = orderBy;
  }

  return request({
    method: 'GET',
    params,
    url: endpoints.DATASETS,
  });
};

const dataset = (code) => request({
  method: 'GET',
  url: datasetEndpoint(code),
});

const create = ({
  steps,
  settings,
  catalogue,
  dictionaries,
}) => {
  const data = {
    catalogue: transformForm(catalogue),
    code: steps.code,
    dictionaries: transformDictionaries(dictionaries),
    settings: cloneDeep(settings),
  };

  if (!hasMinimumLength(data.settings.workflow_key)) { delete data.settings.workflow_key; }
  if (!hasMinimumLength(data.settings.catalogue_definition_code)) { delete data.settings.catalogue_definition_code; }
  if (!hasMinimumLength(data.code)) { delete data.code; }
  if (dictionaries && dictionaries.length === 0) { delete data.dictionaries; }
  const sanitizedProperties = sanitizedDataset(data);

  return request({
    data: sanitizedProperties,
    method: 'POST',
    url: endpoints.DATASETS,
  });
};

const destroy = ({ code }) => request({
  method: 'DELETE',
  url: datasetEndpoint(code),
});

const update = (code, properties) => {
  const sanitizedProperties = sanitizedDataset(properties);
  return (
    request({
      data: sanitizedProperties,
      method: 'PATCH',
      url: datasetEndpoint(code),
    })
  );
};

const DatasetsService = {
  datasets,
  dataset,
  create,
  update,
  destroy,
};

export default DatasetsService;
